/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Collapse_AllInputs */



/**
* | output |
* | --- |
* | "Collapse all" |
*
* @param {Decks_Collapse_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_collapse_all = /** @type {((inputs?: Decks_Collapse_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Collapse_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout réduire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contraer todo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Recolher tudo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comprimi tutto")
	return /** @type {LocalizedString} */ ("Collapse all")
});